let menu = {
    init() {

        $('.burger-menu').click(function(){
            $(this).toggleClass('active');
            $('body').toggleClass('noscroll');
            $('.menu-container').toggleClass('active');
        })

        $('.menu-container li.nolink > a').each(function(){
            $(this).removeAttr('href');
        })


        // var ww = $(window).width();
        // if(ww <= 900){
        //     $('.sub-menu').hide();
        //     $('.nolink').click(function(){
        //         $('.sub-menu').slideUp(300);
        //         $('ul', this).slideDown(300);
        //     })
        //     $('.item-home a').click(function(event){
        //         event.preventDefault();
        //         $('.sub-menu').slideUp(300);
        //         $(this).parent().find('.sub-menu').slideDown(300);
        //     })
        // }


        $('.sub-menu').hide();
        $('.nolink').click(function(){

            if($(this).hasClass('active')){
                $(this).removeClass('active');
                $('a', this).removeClass('active');
                $('.sub-menu').slideUp(300);

            }else{
                $('.nolink').removeClass('active');
                $(this).addClass('active');
                $('.nolink a').removeClass('active');
                $('a', this).addClass('active');
                $('.sub-menu').slideUp(300);
                $('.sub-menu',this).slideDown(300);
            }
        })



        $('.anchor').click(function(){
            $('.burger-menu').toggleClass('active');
            $('body').toggleClass('noscroll');
            $('.menu-container').toggleClass('active');
        })

    }
}

export default menu;
